export default "__VITE_ASSET__1b4f4680__"